export enum AccordionBackgroundColor {

    GREY = 'grey',
    GREEN = 'green',
    PINK = 'pink',
    BLUE = 'blue',
    PURPLE = 'purple',
    BEIGE = 'beige',
    BROWN = 'brown'
}